const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const isValidEmail = email => emailRegex.test(email);

const isNullOrWhiteSpace = value => !value || /^ *$/.test(value);

export default { isValidEmail, isNullOrWhiteSpace };



// WEBPACK FOOTER //
// ./src/validation.js